import React, { Component } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Recaptcha from "react-recaptcha";
import { vville, variablesSubstitution, url } from "../components/Variables-en";
import Spinner from "../components/Spinner-en";
import { navigate } from "gatsby";

export default class Contact extends Component {
  constructor(props) {
    super();

    this.state = {
      site: vville,
      url: url,
      date: new Date().getTime().toString(),
      verified: false,
      verificationAlert: false,
      email: "",
      SubmitButtonClicked: false,
      call: "",
      canal: "",
      source: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.verificationCallback = this.verificationCallback.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      SubmitButtonClicked: true,
    });

    // Get Select element
    const form = event.target;
    const formData = new FormData(form);
    console.log(new URLSearchParams(formData).toString());
    const formJson = Object.fromEntries(formData.entries());

    if (this.state.verified) {
      fetch(
        "https://us-central1-cci-firebase2022.cloudfunctions.net/sendMessageEn",
        {
          method: "post",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phone: this.state.phone,
            zipcode: this.state.zipcode,
            description: this.state.description,
            totalSurface: this.state.totalSurface,
            studiedSurface: this.state.studiedSurface,
            call: this.state.call,
            canal: this.state.canal,
            source: formJson.source,
            how: this.state.how,
            site: this.state.site,
            date: this.state.date,
            url: this.state.url,
          }),
        }
      ).then(() => navigate("/en/sent-message/"));
    } else {
      this.setState({
        verificationAlert: true,
      });
    }
  }

  verificationCallback() {
    this.setState({
      verified: true,
      verificationAlert: false,
    });
  }

  render() {
    return (
      <Section id="contact-block">
        <FlexWrapper>
          <Col1 className="col1">
            <form onSubmit={this.handleSubmit}>
              <BlockTitle className="block-title">
                Send us a project request
              </BlockTitle>
              <P>
                Please send us your project request using the form below. Upon
                receipt of your message, we will get in touch to discuss your
                project and schedule you an appointment on site.
              </P>
              <InputHalf1
                name="firstName"
                type="text"
                onChange={this.handleInputChange}
                placeholder="Your first name *"
                aria-label="Your first name"
                required
              />
              <InputHalf2
                name="lastName"
                type="text"
                onChange={this.handleInputChange}
                placeholder="Your last name *"
                aria-label="Your last name"
                required
              />
              <Input
                name="email"
                type="email"
                onChange={this.handleInputChange}
                placeholder="E-mail address *"
                aria-label="E-mail address"
                required
              />
              <InputHalf1
                name="phone"
                type="tel"
                onChange={this.handleInputChange}
                placeholder="Phone number *"
                aria-label="Phone number"
                required
              />
              <InputHalf2
                name="zipcode"
                type="text"
                onChange={this.handleInputChange}
                placeholder="Zipcode *"
                aria-label="Zipcode of the project"
                required
              />
              <Textarea
                name="description"
                value={this.state.description}
                onChange={this.handleInputChange}
                placeholder="Description of your project *"
                aria-label="Description of your project"
                required
              />
              <Input
                name="studiedSurface"
                type="text"
                onChange={this.handleInputChange}
                placeholder="Surface to study (in m²)"
                aria-label="Surface to study (in m²)"
              />

              <label for="canal" id="canal">
                How would you like to be contacted? *
              </label>
              <Select
                name="canal"
                onChange={this.handleInputChange}
                className={this.state.canal.length > 1 && "active-select"}
                required
              >
                <option value="" disabled selected hidden>
                  How would you like to be contacted? *
                </option>
                <option value="Par téléphone">By phone</option>
                <option value="Par email">By email</option>
                <option value="Par SMS / Whatsapp">By text messagep</option>
              </Select>

              {this.state.canal === "Par téléphone" && (
                <Input
                  name="call"
                  type="text"
                  onChange={this.handleInputChange}
                  placeholder="When would you like to be called back?"
                  aria-label="When would you like to be called back?"
                />
              )}

              <label for="source" id="source">
                How did you hear about us? *
              </label>
              <Select
                name="source"
                onChange={this.handleInputChange}
                className={this.state.source.length > 1 && "active-select"}
              >
                <option value="" disabled selected hidden>
                  How did you hear about us? *
                </option>
                <option value="Search engine">Search engine</option>
                <option value="Social media">Social media</option>
                <option value="BHV partnership">BHV partnership</option>
                <option value="J'ai déjà fait appel à vos services">
                  I have engaged with your services in the past
                </option>
                <option value="Press">Press</option>
              </Select>

              <input
                name="site"
                type="text"
                defaultValue={this.state.site}
                css={css`
                  display: none;
                `}
              />

              <input
                name="timestamp"
                type="text"
                defaultValue={this.state.timestamp}
                css={css`
                  display: none;
                `}
              />

              <input
                name="url"
                type="text"
                defaultValue={this.state.url}
                css={css`
                  display: none;
                `}
              />

              {this.state.email.length > 1 && (
                <RecaptchaDiv>
                  <Recaptcha
                    sitekey="6Lct8ooUAAAAAMhjpAWi1U49SMXb84s43FPtMvax"
                    render="explicit"
                    verifyCallback={this.verificationCallback}
                    hl="en"
                  />
                </RecaptchaDiv>
              )}
              <div
                css={css`
                  clear: both;
                `}
              />

              {this.state.SubmitButtonClicked === false && (
                <InputButton type="submit" value="Send" />
              )}

              <div
                css={css`
                  clear: both;
                `}
              />
              {this.state.SubmitButtonClicked === true &&
                this.state.verified === true && <Spinner />}

              {this.state.verificationAlert && (
                <div
                  css={css`
                    color: red;
                  `}
                >
                  Please fill all required fields
                </div>
              )}
            </form>
          </Col1>
          <Col2 className="col2">
            <Img
              src="/visuels-home-contact/marseille.jpg"
              style={{ borderRadius: "4px", marginTop: "5px" }}
              alt={variablesSubstitution(
                "Contact an interior designer rville and rdepartement"
              )}
            />
          </Col2>
          <Col3 className="contact-info">
            <p>
              You want to send an <strong>attachment</strong>? Please add a link
              to a hosting service (such as Wetransfer, Dropbox, Google Drive,
              …) in the description field of your project.
            </p>
            <p>
              You want to send an <strong>attachment by email?</strong> Please
              send it to us by filling in the following information (telephone,
              postal code, description of the project and area concerned) by
              clicking on{" "}
              <a href="mailto:philippe@createursdinterieur.com?subject=Demande%20de%20projet&body=Nom%20+%20Prénom%20:%0A%0ANuméro%20de%20téléphone%20:%0A%0ACode%20postal%20du%20projet%20:%0A%0ADescription%20du%20projet%20:%0A%0ASurface%20à%20étuder%20en%20m2%20:%0A%0A">
                this link
              </a>
              .
            </p>
          </Col3>
        </FlexWrapper>
      </Section>
    );
  }
}

const Section = styled.div`
  background-image: radial-gradient(#cecdcd 1px, transparent 0);
  background-size: 8px 8px;
`;

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 1.25em 0;
  max-width: 1250px;
  margin: 0 auto;
  @media (max-width: 1250px) {
    padding: 2.5em 15px;
  }
`;

const Col1 = styled.div`
  width: 64.5%;
  padding-right: 30px;
  @media (max-width: 800px) {
    width: 100%;
    margin-bottom: 5px;
    padding-right: 0;
    order: 2;
  }
`;

const Col2 = styled.div`
  width: 35.5%;
  padding-left: 20px;

  @media (max-width: 800px) {
    width: 100%;
    padding-left: 0;
    order: 1;
  }
`;

const Col3 = styled.div`
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  padding: 0.25em 0.35em 0.1em;
  border-radius: 3px;
  margin-bottom: 20px;
  @media (max-width: 800px) {
    width: 100%;
    order: 3;
  }
`;

const BlockTitle = styled.div`
  font-family: "Raleway", sans-serif;
  color: #333;
  background-color: rgba(255, 255, 255, 1);
  display: block;
  width: fit-content;
  margin-top: 0;
  margin-bottom: 0.5em;
  font-weight: 700;
  font-size: 26px;
  letter-spacing: 0.04em;
  line-height: 28px;
  padding: 0 0.3em;
`;

const P = styled.p`
  display: block;
  padding: 0.3em 0.25em 0.25em 0.55em;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  margin-bottom: 25px;
`;

const Textarea = styled.textarea`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  letter-spacing: 0.025em;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 45%) !important;
  width: 100%;
  height: 140px;
  min-height: 100px;
  margin-bottom: 1.8em;
  font-size: 14px;
  padding: 0.5em 0.6em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
`;

const Input = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  box-shadow: 0px 8px 13px -13px rgb(0 0 0 / 45%) !important;
  width: 100%;
  margin-bottom: 1.8em;
  font-size: 14px;
  padding: 0.5em 0.6em;
  letter-spacing: 0em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
`;

const InputHalf1 = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  box-shadow: 0px 8px 13px -13px rgb(0 0 0 / 45%) !important;
  width: 48%;
  margin-right: 2%;
  margin-bottom: 1.8em;
  font-size: 14px;
  padding: 0.5em 0.6em;
  letter-spacing: 0em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
  }
`;

const InputHalf2 = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  box-shadow: 0px 8px 13px -13px rgb(0 0 0 / 45%) !important;
  width: 48%;
  margin-left: 2%;
  margin-bottom: 1.8em;
  font-size: 14px;
  padding: 0.5em 0.6em;
  letter-spacing: 0em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
  }
`;

const InputButton = styled.input`
  float: right;
  margin: 0px 0 5px; !important;
  border: 1px solid #7a9282 !important;
  border-radius: 4px;
  font-weight: 700 !important;
  padding: 0.35em 1.5em 0.45em !important;
  font-size: 0.95em !important;
  color: white !important;
  background-color: #7a9282 !important;
  letter-spacing: 0.07em !important;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
  &:hover, &:focus {
    color: white;
    background-color: #202020 !important;
    border: 1px solid #202020 !important;
    transition: all 0.1s ease-in-out !important;
  }
  &:focus {
 
  }
`;

const Select = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  color: #757575;
  background-color: white;
  box-shadow: 0px 8px 13px -13px rgb(0 0 0 / 45%) !important;
  width: 100%;
  margin-bottom: 1.8em;
  font-size: 15px;
  padding: 0.5em 0.6em;
  letter-spacing: 0em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
`;

const RecaptchaDiv = styled.div`
  float: right;
`;

const Img = styled.img`
  width: 100%;
`;
